
import { MenuAlt1Icon } from '@vue-hero-icons/outline';

export default {
  components: {
    MenuAlt1Icon,
  },

  data() {
    return {
      hasLeft: false,
    };
  },

  methods: {
    toggleSidebar() {
      this.hasLeft = !this.hasLeft;
    },

    showAccountAction() {
      const refAccountAction = this.$refs.refAccountAction;
      refAccountAction && refAccountAction.classList.toggle('show');
    },

    closeDropdown() {
      const refAccountAction = this.$refs.refAccountAction;
      refAccountAction && refAccountAction.classList.remove('show');
    },
  },
};
